// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

import nupayIcon from './icons/nupay-icon.svg';

export function NupayHeader(): Node {
  return (
    <Root>
      <IconWrapper>
        <Icon src={nupayIcon} alt="NuPay"/>
      </IconWrapper>
    </Root>
  );
}

const Root = styled.div `
  align-items: center;
  padding: 16px 32px 4px;
`;

const Icon = styled.img`
  width: 150px;
  height: 50px;
`;

const IconWrapper = styled.div`
  display: block;
  width: 100%;
`;
